import React, { FC, useEffect, Fragment, useState } from "react";
import uuid from "uuid";
// import { Track } from '../../../models/track'
import { connect } from "react-redux";
import { RootState } from "../../../store/reducers";
import { Track, TComment } from "../../../models/track";
import "./comments.css";
import Comment from "./Comment";
import { addComment } from "../../../store/actions/track";
import { match, withRouter } from "react-router-dom";
import { firestore, storage } from "../../../firebase";
import UIkit from "uikit";
import ArtistCard from "../../cards/ArtistCard";
import { User } from "../../../models/user";
import moment from "moment";
import { AnimatePresence, motion } from "framer-motion";

interface RProps<Params extends { tid: string } = { tid: string }> {
  history: any;
  location: any;
  match: match<Params>;
  staticContext?: any;
}

interface CProps {
  users: User[];
  track?: Track;
  isAuthenticated: boolean;
  user: {
    id: string;
    username: string;
  };
}

const Comments: FC<CProps & RProps> = ({
  track,
  isAuthenticated,
  users,
  user,
  match: {
    params: { tid },
  },
}) => {
  const [comment, setComment] = useState("");
  const [tcover, setTcover] = useState("");
  const [comments, setComments] = useState<TComment[]>([]);
  const [loadComments, setLoading] = useState<boolean>(true);
  const [misc, setMisc] = useState<boolean>(false);

  useEffect(() => {
    let mounted = true;

    if (track) {
      storage
        .ref(`covers/${track?.uid}${track?.covername}`)
        .getDownloadURL()
        .then((url) => {
          if (mounted) setTcover(url);
        });
    }

    firestore
      .collection("comments")
      .doc(tid)
      .onSnapshot((snap) => {
        if (snap.exists) {
          let data = snap.data();

          if (mounted) {
            if (!misc)
              setComments(
                data?.comments.sort((a: TComment, b: TComment) =>
                  moment().diff(a.date, "seconds") > moment().diff(b.date)
                    ? 1
                    : -1
                )
              );
            setMisc(true);

            setLoading(false);
          }
        } else setLoading(false);
      });

    // .get()
    // .then((snap) => {
    //   if (snap.exists) {

    // })
    // .catch(() => setLoading(false))

    return () => {
      mounted = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="app-view">
      <div className="app-view-body" id="comments">
        <div
          style={{
            margin: "auto",
            width: "90%",
            paddingBottom: "24px",
            borderBottom: "1px solid var(--grey)",
          }}
        >
          <div className="tc-head">
            <div className="tc-img">
              {tcover && (
                <img
                  src={tcover}
                  width={100}
                  height={100}
                  alt={track?.covername}
                />
              )}
            </div>
            <div className="tc-dets">
              <div>
                <b>{track?.title}</b>
              </div>
              <div>
                <i className="material-icons-outlined thmcl  md-18">
                  favorite_border
                </i>
                {track?.likes.length}
              </div>
              <div>
                <i className="material-icons-outlined thmcl">play_arrow</i>
                {track?.plays.length}
              </div>
            </div>
          </div>
        </div>

        <div
          className="csbody"
          style={{
            margin: "auto",
            width: "90%",
            paddingBottom: "24px",
          }}
        >
          {isAuthenticated && track?.commenting && (
            <div
              className="comment-form  uk-margin-small-top"
              style={{
                borderBottom: "1px solid var(--grey)",
                paddingBottom: "16px",
              }}
            >
              <form
                className="uk-form-blank"
                onKeyUp={(e) => {
                  if (e.type === "enter") console.log("Enter");
                }}
                onSubmit={async (e) => {
                  e.preventDefault();
                  if (!comment)
                    return UIkit.notification({
                      message: "Enter a comment",
                      status: "warning",
                    });
                  let c: TComment = {
                    user: user,
                    body: comment,
                    date: new Date(Date.now()).toISOString(),
                    id: uuid.v4(),
                    tid: track.id,
                  };
                  let resp = await addComment(c);

                  if (resp) setComment("");
                }}
              >
                <textarea
                  value={comment}
                  className="uk-textarea"
                  onChange={(e) => {
                    setComment(e.currentTarget.value);
                    setComments(comments);
                  }}
                ></textarea>
                <button
                  className="uk-button-small uk-margin-small-top uk-border-pill"
                  style={{ cursor: "pointer" }}
                >
                  Add comment
                </button>
              </form>
            </div>
          )}

          {track?.commenting ? (
            <Fragment>
              {loadComments ? (
                <span data-uk-spinner="ratio: 2"></span>
              ) : (
                <Fragment>
                  {comments.length > 0 ? (
                    <AnimatePresence>
                      {comments &&
                        comments.map((comment, i) => (
                          <motion.div
                            key={i}
                            initial={{
                              scale: 0.4,
                            }}
                            animate={{
                              scale: 1,
                            }}
                            exit={{
                              y: -90,
                            }}
                          >
                            <Comment comment={comment} />
                          </motion.div>
                        ))}
                    </AnimatePresence>
                  ) : (
                    <h4>No comments yet</h4>
                  )}
                </Fragment>
              )}
            </Fragment>
          ) : (
            <h4>Commenting disabled by owner</h4>
          )}
        </div>
      </div>
      <div className="app-view-extra ls">
        <div className="extras-body">
          <div>
            <div className="artist">
              <div
                className="artist-name"
                style={{ fontSize: "24px", marginBottom: "8px" }}
              >
                Featured
              </div>
            </div>
            <div style={{ display: "flex", flexWrap: "wrap" }}>
              {users &&
                users.map((user) => <ArtistCard user={user} key={user.id} />)}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state: RootState, ownProps: RProps) => ({
  track: state.data.list.find((t) => t.id === ownProps.match.params.tid),
  isAuthenticated: state.auth.isAuthenticated,
  user: {
    id: state.auth.user.id,
    username: state.auth.user.username,
  },
  users: state.data.users,
});

export default withRouter(connect(mapStateToProps)(Comments));
